<template>
  <section class="pd-y-30">
    <div class="container" style="max-width: 600px !important">
      <div class="section-title">
        <h2>{{ comp.task }}</h2>
        <p>{{ comp.f1 }}</p>
      </div>
    </div>
    <div class="container">
      <ul class="list-unstyled">
        <li class="media d-block d-sm-flex" v-for="(t, i) in tasks" :key="i">
          <router-link
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: {
                id: $store.state.app.contentPageId,
                cid: t.id
              }
            }"
          >
            <img
              :src="`${t.defaultAttachmentUrl}?w=460&h=360&mode=crop`"
              class="wd-100p wd-sm-200 rounded mg-sm-r-20 mg-b-20 mg-sm-b-0"
              alt
            />
          </router-link>
          <div class="media-body">
            <h5 class="mg-b-10 tx-inverse">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: {
                    id: $store.state.app.contentPageId,
                    cid: t.id
                  }
                }"
                >{{ t.task }}</router-link
              >
            </h5>
            {{ t.f1 }}
            <div class="text-orange">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: {
                    id: $store.state.app.contentPageId,
                    cid: t.id
                  }
                }"
                >{{ t.createdDate | moment("YYYY.MM.DD") }}</router-link
              >
            </div>
          </div>
        </li>
      </ul>
      <!-- <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" v-for="(t,i) in tasks" :key="i">
            <div class="card">
              <router-link :to="({name: $store.state.app.activeGroup.publicPage.route, params:{
                id: $store.state.app.contentPageId, cid: t.id
              }})">
                <img    :src="`${t.defaultAttachmentUrl}?w=460&h=360&mode=crop`" class="card-img wd-100p" />
                <div class="card-body">
                  <h5 class="card-title text-truncate">{{t.task}}</h5>
                  <div class="text-orange">{{t.createdDate | moment('YYYY.MM.DD')}}</div>
                </div>
              </router-link>
            </div>
          </div>
      </div>-->
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style></style>
